import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
import _imports_0 from '../../assets/images/StarIcon.svg';
const _hoisted_1 = { class: "d-flex flex-column gap-4" };
const _hoisted_2 = { class: "d-flex flex-wrap gap-3 align-items-center justify-content-between position-relative" };
const _hoisted_3 = {
    key: 0,
    class: "classic-title header-title mb-0 fs-2 title-color"
};
const _hoisted_4 = {
    key: 0,
    class: "overflow-hidden d-flex gap-2 mb-0 position-absolute xp-counter"
};
const _hoisted_5 = { class: "d-flex xp-text" };
const _hoisted_6 = { class: "d-flex position-relative" };
const _hoisted_7 = { class: "new-digit-container d-flex position-absolute" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = {
    key: 0,
    class: "academic-title header-title mb-0 fs-2 title-color"
};
const _hoisted_10 = {
    key: 1,
    class: "mb-0 fs-5 header-subtitle title-color"
};
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import NotificationItems from '../items/NotificationItems.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DynamicHeader',
    props: {
        headerTitle: {},
        headerSubTitle: {}
    },
    emits: ['redirectUserToPage'],
    setup(__props, { emit: __emit }) {
        const emits = __emit;
        const store = useStore();
        const userPoints = computed(() => store.getters.getUserPoints);
        const userRole = computed(() => store.getters.getType);
        const userBelongsToAcademicRoles = computed(() => store.getters.getUserBelongsToAcademicRoles);
        const renderXP = computed(() => Boolean(userRole.value === 'student'));
        const screenX = computed(() => store.getters.getUserWidth);
        const arrayUserXP = computed(() => !!userXP.value ? userXP.value.toString().split('') : []);
        const arrayUserUpdatedXP = computed(() => !!userUpdatedXP.value ? userUpdatedXP.value.toString().split('') : []);
        const userUpdatedXP = computed(() => userPoints.value);
        const userXP = ref(userPoints.value);
        const digitXPToUpdate = ref([]);
        const starSpin = ref(false);
        const redirectUserToPage = () => {
            emits('redirectUserToPage');
        };
        const validateXPDigitsToUpdate = () => {
            digitXPToUpdate.value = arrayUserUpdatedXP.value.flatMap((digit, index) => (arrayUserXP.value[index] !== digit ? [index] : []));
            starSpin.value = true;
            arrayUserUpdatedXP.value.length !== arrayUserXP.value.length && (arrayUserXP.value.push('0'));
            setTimeout(() => {
                resetDataRelatedToAnimations();
            }, 750);
        };
        const resetDataRelatedToAnimations = () => {
            userXP.value = userUpdatedXP.value;
            digitXPToUpdate.value = [];
            starSpin.value = false;
        };
        watch(userUpdatedXP, () => {
            validateXPDigitsToUpdate();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: _normalizeClass([userBelongsToAcademicRoles.value ? 'flex-column justify-content-center align-items-start' : 'align-items-center', 'd-flex  gap-3'])
                    }, [
                        _createElementVNode("button", {
                            onClick: redirectUserToPage,
                            class: _normalizeClass([screenX.value < 1024 ? 'bg-transparent' : 'page-back-button-background',
                                'page-back-button px-2 border-0 d-flex justify-content-end align-items-center'])
                        }, [...(_cache[0] || (_cache[0] = [
                                _createElementVNode("i", { class: "bi page-back-icon bi-arrow-left-short" }, null, -1)
                            ]))], 2),
                        (!userBelongsToAcademicRoles.value && __props.headerTitle)
                            ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(__props.headerTitle), 1))
                            : _createCommentVNode("", true)
                    ], 2),
                    (renderXP.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("img", {
                                alt: "Estrela Amarela",
                                class: _normalizeClass([starSpin.value && ('rotate-720'), ' star-image']),
                                src: _imports_0
                            }, null, 2),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrayUserXP.value, (digit, index) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                            class: _normalizeClass([digitXPToUpdate.value.includes(index) && ('old-digit'), 'fw-bold xp-digit'])
                                        }, _toDisplayString(digit), 3));
                                    }), 256)),
                                    _createElementVNode("div", _hoisted_7, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrayUserUpdatedXP.value, (digit, index) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                                class: _normalizeClass([digitXPToUpdate.value.includes(index) ? 'new-digit' : 'new-digit-hidden', ' fw-bold xp-digit'])
                                            }, _toDisplayString(digit), 3));
                                        }), 256))
                                    ])
                                ]),
                                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mb-0 ms-1" }, "XP", -1))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    ((userBelongsToAcademicRoles.value && screenX.value > 1024))
                        ? (_openBlock(), _createBlock(NotificationItems, {
                            key: 1,
                            class: "notification-items",
                            renderedInSidebar: false
                        }))
                        : _createCommentVNode("", true)
                ]),
                (__props.headerSubTitle || (userBelongsToAcademicRoles.value && __props.headerTitle))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (userBelongsToAcademicRoles.value && __props.headerTitle)
                            ? (_openBlock(), _createElementBlock("h1", _hoisted_9, _toDisplayString(__props.headerTitle), 1))
                            : _createCommentVNode("", true),
                        (__props.headerSubTitle)
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_10, _toDisplayString(__props.headerSubTitle), 1))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
